export default __webpack_public_path__ + "static/media/i017vp.83a6fb26.webp";